import { AnimatePresence } from "framer-motion";

const AnimateWrapper = ({ children, animate, setAnimate }) => {
  return <AnimatePresence>{animate && children}</AnimatePresence>;
};
//AnimateWrapper 是一个函数式组件，接受三个属性作为参数：children：这是一个特殊的属性，它代表了 AnimateWrapper 组件的子组件，即在 AnimateWrapper 组件内部包裹的任何 React 元素或组件。animate：这是一个布尔值属性，通常用于控制是否应该执行动画效果。setAnimate：这是一个函数属性，通常用于设置或切换 animate 属性的值，以触发或停止动画效果。在组件的返回部分，它包含了一个 React 组件 <AnimatePresence>用于管理动画的进入和退出效果。总结来说，AnimateWrapper 是一个用于包装动画效果的 React 组件。它接受一个布尔值属性 animate，该属性控制是否要显示子组件并触发动画效果。如果 animate 属性为 true，则渲染 children 並显示动画效果，否则不渲染。通常，setAnimate 函数用于在需要时更改 animate 属性的值，以启动或停止动画效果。这种模式常用于创建动态的、基于条件的动画效果的组件。
export default AnimateWrapper;
